$(function(){
	gsap.registerPlugin(ScrollTrigger);
	
	gsap.fromTo(".md-int-header__image img", 
	  {
		//filter: "blur(20px)",
		alpha: 0,
		scale: 1.2,
	  },
	  {
		//filter: "blur(0px)",
		alpha: 1,
		scale: 1,
		duration: 3,
		ease: "power3.out"
	  }
	);
	
	gsap.fromTo(".md-int-fixedheader",
	  { y: "-80px" },
	  {
		y: 0,
		ease: "power2.out",
		scrollTrigger: {
		  trigger: ".md-int-header",
		  start: "bottom top",
		  toggleActions: "play none none reverse"
		}
	  }
	);
	
	gsap.fromTo(".md-int-fixedheader",
	  { y: "-80px" },
	  {
		y: 0,
		ease: "power2.out",
		scrollTrigger: {
		  trigger: ".md-look-title",
		  start: "bottom top",
		  toggleActions: "play none none reverse"
		}
	  }
	);
	
	$('.md-int-itemlist__item,.md-int-list__item').click(function(){
		var linkURL = $(this).find('a').attr('href');
		if(linkURL){
			window.location.href = linkURL;
		}
	});
	
	const $grid = $('.md-look');
	
	function toggleStacking(callback) {
		$grid.find('.md-look-grid').fadeOut(300, function() {
			$grid.toggleClass('stacking');
			$('html, body').animate({ scrollTop: $grid.offset().top }, 300);
			
			$grid.find('.md-look-grid').fadeIn(300, function() {
				ScrollTrigger.refresh();
				const $firstItem = $('.md-look-grid__item').first();
				$('.md-look-desc__item').removeClass('active');
				$('.' + $firstItem.data('item')).addClass('active');
				
				if (typeof callback === "function") callback();
			});
		});
	}
	
	$('.md-look-change').click(function() {
		toggleStacking();
	});
	
	$(document).on('click', '.md-look:not(.stacking) .md-look-grid__item', function() {
	  const $clicked = $(this);
	  const $look = $clicked.closest('.md-look');
	  const dataItem = $clicked.data('item');
	
	  $look.find('.md-look-grid').fadeOut(300, function() {
		$look.toggleClass('stacking');
		
		$look.find('.md-look-grid').css({display: 'flex',opacity: 0});
		ScrollTrigger.refresh();
		
		let offsetTop = $clicked.offset().top;
		if ($(window).width() <= 768) {
		  offsetTop = offsetTop - 80;
		}
		$('html, body').scrollTop(offsetTop);
		
		$look.find('.md-look-grid').animate({ opacity: 1 }, 300);
		$('.md-look-desc__item').removeClass('active');
		$('.' + dataItem).addClass('active');
	  });
	});
	
	gsap.utils.toArray('.md-look-grid__item').forEach(target => {
	  let dataItem = target.dataset.item;
	
	  ScrollTrigger.create({
		trigger: target,
		start: "top center",
		end: "bottom center",
		markers: false,
		onEnter: () => {
		  document.querySelectorAll('.' + dataItem).forEach(el => el.classList.add('active'));
		},
		onEnterBack: () => {
		  document.querySelectorAll('.' + dataItem).forEach(el => el.classList.add('active'));
		},
		onLeave: () => {
		  document.querySelectorAll('.' + dataItem).forEach(el => el.classList.remove('active'));
		},
		onLeaveBack: () => {
		  document.querySelectorAll('.' + dataItem).forEach(el => el.classList.remove('active'));
		}
	  });
	});
	
	$('.md-look-grid__caption').each(function() {
	  const $caption = $(this);
	  const dataItem = $caption.data('item');
	
	  const htmlContent = $('.' + dataItem).html();
	  $caption.html(htmlContent);
	});

	// web01 & web02 ヒーロー＆パララックス
	(function() {
	  var heroBg   = document.getElementById('md-hero-bg');
	  var heroText = document.getElementById('md-hero-text');
	  var hero     = document.getElementById('md-hero');
	  var parallax = document.getElementById('md-web01-parallax') || document.getElementById('md-web02-parallax');

	  if (!hero && !parallax) return;

	  function onScroll() {
	    var scrollY = window.scrollY || window.pageYOffset;

	    if (hero) {
	      var heroH = hero.offsetHeight;
	      if (scrollY <= heroH) {
	        if (heroBg)   heroBg.style.transform   = 'translateY(' + (scrollY * 0.4) + 'px)';
	        if (heroText) heroText.style.transform = 'translateY(' + (scrollY * -0.3) + 'px)';
	      }
	    }

	    if (parallax) {
	      var rect = parallax.getBoundingClientRect();
	      var winH = window.innerHeight;
	      if (rect.top < winH * 0.5) {
	        parallax.classList.add('is-active');
	      }
	    }
	  }

	  window.addEventListener('scroll', onScroll, { passive: true });
	  onScroll();
	})();
		// web03 ヒーロー＆パララックス＆スライダー
	(function() {
	  var hero     = document.getElementById('md-web03-hero');
	  var heroBg   = document.getElementById('md-web03-hero-bg');
	  var heroText = document.getElementById('md-web03-hero-text');
	  var parallax = document.getElementById('md-web03-parallax');

	  if (!hero && !parallax) return;

	  function onScroll() {
	    var scrollY = window.scrollY || window.pageYOffset;

	    if (hero && scrollY <= hero.offsetHeight) {
	      if (heroBg)   heroBg.style.transform   = 'translateY(' + (scrollY * 0.4) + 'px)';
	      if (heroText) heroText.style.transform = 'translateY(' + (scrollY * -0.3) + 'px)';
	    }

	    if (parallax && parallax.getBoundingClientRect().top < window.innerHeight * 0.5) {
	      parallax.classList.add('is-active');
	    }
	  }

	  window.addEventListener('scroll', onScroll, { passive: true });
	  onScroll();

	  // 店舗スライダー＋スタッフ写真スライダー
	  function initSwipers() {
	    document.querySelectorAll('.md-web03__swiper, .md-web03__staff-swiper').forEach(function(el) {
	      if (el.swiper) return;
	      new Swiper(el, {
	        slidesPerView: 1,
	        rewind: true,
	        autoHeight: el.classList.contains('md-web03__staff-swiper'),
	        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
	        navigation: {
	          nextEl: el.querySelector('.swiper-button-next'),
	          prevEl: el.querySelector('.swiper-button-prev')
	        }
	      });
	    });
	  }

	  if (typeof Swiper !== 'undefined') {
	    initSwipers();
	  } else {
	    var s = document.createElement('script');
	    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.14/swiper-bundle.min.js';
	    s.onload = initSwipers;
	    document.head.appendChild(s);
	  }
	})();
});